import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manhwa';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-white text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                虚空韩漫网
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              提供顺畅的韩漫在线阅读体验，聚合韩国漫画网免费在线观看的韩国漫画，资源整合能力强。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(1, 7).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/all"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  全部漫画
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#faq"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  常见问题
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                <span>contact@xkmanhua.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-500"></i>
                <span>每日更新，全年无休</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2024-2026 虚空韩漫网. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-foreground-700 transition-colors">
              隐私政策
            </a>
            <a href="#" className="hover:text-foreground-700 transition-colors">
              使用条款
            </a>
            <a href="#" className="hover:text-foreground-700 transition-colors">
              版权声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}